import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoodsComponent } from './goods.component';
import { CoreModule } from '@core/core.module';
import { UIModule } from '@common/UI/UI.module';
import { DirectivesModule } from '@common/directives/directives.module';
import { NgxLoadingModule } from 'ngx-loading';
import { EditorsModule } from '@routes/editors/editors.module';
import { InvoicesModule } from '@routes/invoices/invoices.module';



@NgModule({
  declarations: [
    GoodsComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    UIModule,
    InvoicesModule,
    DirectivesModule,
    NgxLoadingModule,
    EditorsModule
  ],

  exports: [
    GoodsComponent
  ]
})
export class GoodsModule { }
